export default __webpack_public_path__ + "static/media/card-07.cdf50ade.svg";